import { ArtifactMintSteps } from '@app/client/common/structs/nft/artifacts';
import { DEFAULT_ARTIFACT_COUNT, DEFAULT_KEYS_STATE } from '@app/store/types/artifacts';
import {
    ACTION_ARTIFACT_MINT_PANEL_STEP,
    ACTION_SET_ARTIFACT_MINT_PANEL_OPEN,
    type ArtifactsAction,
    type ArtifactsState,
    SET_ARTIFACT_KEYS,
    SET_ARTIFACT_TOTAL_COUNTS,
    SET_ARTIFACTS,
    SET_ARTIFACTS_BREAKDOWN,
    SET_ARTIFACTS_METADATA,
    SET_LOOT_BOX_TOKEN_ID_MAPPING,
    SET_SELECTED_ARTIFACT_MINT_DISPLAY,
    SET_USER_ARTIFACTS,
} from '@app/store/types/artifacts-actions';

const DEFAULT: ArtifactsState = {
    artifactMintPanelStep: ArtifactMintSteps.Select,
    totalCounts: DEFAULT_ARTIFACT_COUNT,
    artifactMintPanelOpen: false,
    lootboxTokenIdMapping: null,
    artifactsBreakdown: null,
    keys: DEFAULT_KEYS_STATE,
    artifactMetadata: null,
    selectedArtifact: null,
    syncedArtifactIds: [],
    artifacts: null,
};

export function artifacts(state: ArtifactsState = DEFAULT, action: ArtifactsAction): ArtifactsState {
    switch (action.type) {
        case SET_ARTIFACTS:
            return { ...state, artifacts: action.artifacts };
        case SET_ARTIFACT_KEYS:
            return { ...state, keys: action.keys };
        case SET_ARTIFACT_TOTAL_COUNTS:
            return { ...state, totalCounts: action.totalCounts };
        case SET_USER_ARTIFACTS: {
            return { ...state, userArtifacts: action.userArtifacts };
        }
        case SET_ARTIFACTS_METADATA: {
            return { ...state, artifactMetadata: action.artifactMetadata };
        }
        case ACTION_SET_ARTIFACT_MINT_PANEL_OPEN: {
            return { ...state, artifactMintPanelOpen: action.artifactMintPanelOpen };
        }
        case ACTION_ARTIFACT_MINT_PANEL_STEP: {
            return { ...state, artifactMintPanelStep: action.artifactMintPanelStep };
        }
        case SET_SELECTED_ARTIFACT_MINT_DISPLAY: {
            return { ...state, selectedArtifact: action.selectedArtifact };
        }
        case SET_ARTIFACTS_BREAKDOWN: {
            return { ...state, artifactsBreakdown: action.artifactsBreakdown };
        }
        case SET_LOOT_BOX_TOKEN_ID_MAPPING: {
            return { ...state, lootboxTokenIdMapping: action.lootboxTokenIdMapping };
        }
        default:
            return state;
    }
}
